import BaseAPI from "@/apis/base/baseApi";
import httpClient from "@/apis/base/httpclient";
import { MSEnum } from '@/commons/enumeration'
class AuthorizedPersonAPI extends BaseAPI {
    constructor() {
        super();
    }

    apiName = "TaskGo";
    controllerName = "AuthorizedPersons";

    /**
       * Lấy danh sách ủy quyền
       * @param {*} payload
       * @returns
       */
    getListAuthorizedPersons(payload) {
        let request = {
            url: this.getAPIUrl() + '/list',
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
       * Lấy danh sách người đc ủy quyền sắp xếp theo cây cơ cấu
       * @returns Danh sách người đc ủy quyền sắp xếp theo cây cơ cấu
       * @author: BMTHang(06/01/2022)
       */
    getAuthorizedPersonByMe() {
        let request = {
            url: this.getAPIUrl() + '/AuthorizedPersonByMe',
        };

        return httpClient.getAsync(request);
    }

    /**
       * Lấy danh sách người ủy quyền cho tôi sắp xếp theo cây cơ cấu
       * @returns Danh sách người ủy quyền cho tôi sắp xếp theo cây cơ cấu
       * @author: BMTHang(06/01/2022)
       */
    getAuthorizedPersonForMe() {
        let request = {
            url: this.getAPIUrl() + '/AuthorizedPersonForMe',
        };

        return httpClient.getAsync(request);
    }

    /**
       * Lưu ủy quyền
       * @param {*} payload
       * @returns
       */
    saveAuthorizedPersons(payload) {
        let request = {
            url: this.getAPIUrl(),
            data: payload
        };
        return httpClient.postAsync(request);
    }

    /**
       * Cập nhật ủy quyền
       * @param {*} payload
       * @returns
       */
    updateAuthorizedPersons(payload) {
        let request = {
            url: this.getAPIUrl(),
            data: payload
        };
        return httpClient.putAsync(request);
    }

    /**
       * Xóa ủy quyền
       * @param {*} payload
       * @returns
       */
    deleteAuthorizedPersons(id, entity) {
        let request = {
            url: this.getAPIUrl(),
            data: {
                id: id,
                entity: entity
            }
        };
        return httpClient.deleteAsync(request);
    }

}

export default new AuthorizedPersonAPI();
